import React from 'react';

const STATUS = {
  pending:  { label: 'Pending',  cls: 'bg-amber-500/10 border-amber-500/30 text-amber-400' },
  active:   { label: 'Active',   cls: 'bg-green-500/10 border-green-500/30 text-green-400' },
  declined: { label: 'Declined', cls: 'bg-red-500/10 border-red-500/30 text-red-400' },
  ended:    { label: 'Ended',    cls: 'bg-zinc-500/10 border-zinc-500/30 text-zinc-500' },
};

const PartnershipStatusBadge = ({ status }) => {
  const s = STATUS[status] || STATUS.pending;
  return (
    <span className={`px-2.5 py-1 rounded-full border text-[10px] font-black uppercase tracking-widest ${s.cls}`}>
      {s.label}
    </span>
  );
};

export default PartnershipStatusBadge;